<template>
    <v-card class="fill-height">
        <v-toolbar card dark color="primary">
            <v-toolbar-title>Registreer een gebruiker</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn flat icon @click="$emit('close')">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-stepper v-model="step" class="fill-height">
            <v-stepper-header>
                <v-stepper-step :complete="step > 1" step="1">Gebruikersnaam</v-stepper-step>
                <v-divider />
                <v-stepper-step :complete="step > 2" step="2">Methode</v-stepper-step>
                <v-divider />
                <v-stepper-step :complete="step > 3" step="3">Authenticatie</v-stepper-step>
                <v-divider />
                <v-stepper-step :complete="step > 4" step="4">Klaar</v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
                <v-stepper-content step="1">
                    <p>Kies een gebruikersnaam zoals bijvoorbeeld: Hendrik.</p>
                    <v-form ref="form" v-model="formValid" @submit.prevent="onSubmit">
                        <v-text-field
                            autofocus
                            label="Gebruikersnaam"
                            v-model="username"
                            :counter="10"
                            :rules="usernameRules"
                            />
                    </v-form>
                </v-stepper-content>

                <v-stepper-content step="2">
                    <p>Er zijn twee manieren om je te registreren.</p>
                    <v-card>
                        <v-card-title>
                            <v-icon class="mr-2">fingerprint</v-icon>
                            <h4>Registreer met je apparaat</h4>
                        </v-card-title>
                        <v-card-text>
                            Gebruik het authenticatiemechanisme van je telefoon/apparaat. Hiermee kun je direct inloggen
                            door middel van je vingerafdruk of pincode.
                        </v-card-text>
                        <v-card-actions>
                            <v-btn :disabled="!platformAvailable" @click="registerPlatform" block color="primary">
                                Registreer
                                {{ !platformAvailable ? '(Niet beschikbaar)' : '' }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>

                    <v-card class="mt-3">
                        <v-card-title>
                            <v-icon class="mr-2">memory</v-icon>
                            <h4>Registreer met een externe sleutel</h4>
                        </v-card-title>
                        <v-card-text>
                            Als je in het bezit bent van een externe beveiligingssleutel
                            (FIDO, U2F, Yubikey) kun je die ook gebruiken.
                        </v-card-text>
                        <v-card-actions>
                            <v-btn @click="registerCrossPlatform" block color="primary">
                                Registreer
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-stepper-content>

                <v-stepper-content step="3">
                    <v-alert :value="true" type="info" border="left">
                        <h4>Volg de instructies</h4>
                        <p>
                            Volg nu de instructies op je telefoon, browser of ander apparaat.
                        </p>
                    </v-alert>
                </v-stepper-content>

                <v-stepper-content step="4">
                    <v-alert :value="true" type="success" border="left">
                        <h4>Het is gelukt!</h4>
                        <p>
                            Gebruiker <strong>{{ username }}</strong> is geregistreerd.
                        </p>
                    </v-alert>
                    <p>
                        Je gaat nu terug naar de overzichtspagina. Daar kun je deze gebruiker aanklikken om
                        te testen of je ook kunt inloggen.
                    </p>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>

        <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="step++" :disabled="!formValid" v-if="step === 1">
                <v-icon class="mr-2">navigate_next</v-icon>
                Volgende
            </v-btn>
            <v-btn color="success" @click="$emit('close')" v-if="step === 4">
                <v-icon class="mr-2">check</v-icon>
                Sluiten
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import client from './client'
import users from './users'

export default {
    data () {
        return {
            step: 1,
            formValid: false,
            username: null,
            platformAvailable: null,
        }
    },
    computed: {
        usernameRules () {
            return [
                v => (v || '').length > 2 || `Gebruik minimaal 2 karakters`,
                v => (v || '').length <= 10 || `Gebruik maximaal 10 karakters`,
                v => /^[a-zA-Z0-9]+$/.test(v) || `Alleen letters en cijfers toegestaan`,
                v => !users.has(v) || `Gebruikersnaam is al bezet`,
            ]
        },
    },
    methods: {
        onSubmit () {
            this.step = 2
        },

        async registerPlatform () {
            try {
                this.step = 3
                await this.$nextTick()
                await client.register(this.username, 'platform')
                this.step = 4
            } catch (e) {
                this.handleError(e)
                this.step = 2
            }
        },
        async registerCrossPlatform () {
            try {
                this.step = 3
                await this.$nextTick()
                await client.register(this.username, 'cross-platform')
                this.step = 4
            } catch (e) {
                this.handleError(e)
                this.step = 2
            }
        },
        handleError (e) {
            if (e.name === 'NotAllowedError') {
                window.alert('Authenticatie is niet gelukt. Heb je de popup waarin werd gevraagd om je te identificeren gesloten? Deze fout komt ook voor als je te lang hebt gewacht.')
                return
            }

            if (e.name === 'UserAuthError') {
                window.alert(e.message)
                return
            }

            window.alert('Onbekende fout: (' + e.name + ') ' + e.message)
        },
    },
    async mounted () {
        this.platformAvailable = await client.plaformAvailable()
    },
}
</script>
